


// import React, { useState } from 'react'
// import { database, ref, set } from '../firebase'

// const Information = () => {
//   const [form, setForm] = useState({
//     adminName: '',
//     mobile: '',
//     password: '',
//   });
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState('');
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccess('');
//     setError('');
//     if (!form.adminName || !form.mobile || !form.password) {
//       setError('All fields are required.');
//       setLoading(false);
//       return;
//     }
//     try {
//       await set(ref(database, `/videoplayer/Users/${form.mobile}`), {
//         adminName: form.adminName,
//         mobile: form.mobile,
//         password: form.password,
//         role: 'admin',
//       });
//       setSuccess('Admin registered successfully!');
//       setForm({ adminName: '', mobile: '', password: '' });
//     } catch (err) {
//       setError('Failed to register admin.');
//     }
//     setLoading(false);
//   };

//   return (
//     <div style={{ maxWidth: 400, margin: '40px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fafbfc', boxShadow: '0 2px 8px #f0f1f2' }}>
//       <h2 style={{ textAlign: 'center', marginBottom: 24 }}>Admin Registration</h2>
//       <form onSubmit={handleSubmit}>
//         <div style={{ marginBottom: 16 }}>
//           <label style={{ display: 'block', marginBottom: 6 }}>Admin Name</label>
//           <input
//             type="text"
//             name="adminName"
//             value={form.adminName}
//             onChange={handleChange}
//             style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//             placeholder="Enter admin name"
//             autoComplete="off"
//           />
//         </div>
//         <div style={{ marginBottom: 16 }}>
//           <label style={{ display: 'block', marginBottom: 6 }}>Mobile Number</label>
//           <input
//             type="tel"
//             name="mobile"
//             value={form.mobile}
//             onChange={handleChange}
//             style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//             placeholder="Enter mobile number"
//             autoComplete="off"
//           />
//         </div>
//         <div style={{ marginBottom: 24 }}>
//           <label style={{ display: 'block', marginBottom: 6 }}>Password</label>
//           <input
//             type="password"
//             name="password"
//             value={form.password}
//             onChange={handleChange}
//             style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//             placeholder="Enter password"
//             autoComplete="off"
//           />
//         </div>
//         <button
//           type="submit"
//           disabled={loading}
//           style={{ width: '100%', padding: 10, borderRadius: 4, background: '#007bff', color: '#fff', border: 'none', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}
//         >
//           {loading ? 'Registering...' : 'Register Admin'}
//         </button>
//         {success && <div style={{ color: 'green', marginTop: 16, textAlign: 'center' }}>{success}</div>}
//         {error && <div style={{ color: 'red', marginTop: 16, textAlign: 'center' }}>{error}</div>}
//       </form>
//     </div>
//   )
// }

// export default Information







import React, { useState, useEffect } from "react";
import {
  database,
  ref,
  set,
  onValue,
  storage,
  storageRef,
  uploadBytes,
  getDownloadURL,
} from "../firebase";
import { Link } from "react-router-dom";
import { useSearch } from "../SearchContext";
import {
  FaUser,
  FaUserTag,
  FaPhone,
  FaLock,
  FaBriefcase,
  FaPercentage,
  FaCreditCard,
  FaQrcode,
  FaCamera,
  FaCheckCircle,
  FaBuilding,
  FaInfoCircle,
  FaTimes,
  FaMobile,
  FaAd,
  FaUpload,
  FaImage,
  FaWhatsapp,
  FaEnvelope,
  FaGlobe,
  FaBars,
  FaTimes as FaClose,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import gpayImg from "../img/gpay.png";
import phonepeImg from "../img/phonepe.svg";

const Information = () => {
  const { youtubeResults, searchQuery } = useSearch();

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    business: "",
    gst: "",
    payment: "",
    terms: false,
    plan: "",
    visitBranch: "", // New field for branch visit
  });

  const [showQR, setShowQR] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [submissionError, setSubmissionError] = useState("");
  const [instructionData, setInstructionData] = useState(null);
  const [subscriptionPlans, setSubscriptionPlans] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAdOverlay, setShowAdOverlay] = useState(false);
  const [adTimer, setAdTimer] = useState(15);
  const [screenshotFile, setScreenshotFile] = useState(null);
  const [screenshotPreview, setScreenshotPreview] = useState("");
  const [isUploadingScreenshot, setIsUploadingScreenshot] = useState(false);
  const [legalInfo, setLegalInfo] = useState(null);
  const [nameError, setNameError] = useState("");
  const [surnameError, setSurnameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [gstError, setGstError] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Contact information - you can customize these values
  const contactInfo = {
    whatsapp: "+91 8262917438",
    whatsapp2: "+91 9673577671",
    email: "timepassservices@gmail.com",
    website: "https://timepassservices.com/",
  };

  // Fetch instruction data and subscription plans from Firebase
  useEffect(() => {
    // console.log('Initializing Firebase connections...');
    // console.log('Database instance:', database);

    const instructionsRef = ref(database, "videoplayer/Information");
    const subscriptionRef = ref(database, "videoplayer/SubscriptionPlans");

    const unsubscribeInstructions = onValue(
      instructionsRef,
      (snapshot) => {
        const data = snapshot.val();
        // console.log('Instructions data received:', data);
        if (data) {
          // Get the first instruction (assuming there's only one or we want the first one)
          const instructionList = Object.entries(data).map(([id, value]) => ({
            id,
            ...value,
          }));
          if (instructionList.length > 0) {
            setInstructionData(instructionList[0]);
            // Show ad overlay if advertisement image exists
            if (instructionList[0].adImageUrl) {
              setShowAdOverlay(true);
            }
          }
        }
      },
      (error) => {
        // console.error('Error fetching instructions:', error);
      }
    );

    const unsubscribeSubscription = onValue(
      subscriptionRef,
      (snapshot) => {
        const data = snapshot.val();
        // console.log('Subscription data received:', data);
        setSubscriptionPlans(data);
      },
      (error) => {
        // console.error('Error fetching subscriptions:', error);
      }
    );

    // Fetch payment information
    const paymentRef = ref(database, "videoplayer/SubscriptionPlans/payment");
    const unsubscribePayment = onValue(
      paymentRef,
      (snapshot) => {
        const data = snapshot.val();
        // console.log('Payment data received:', data);
        setPaymentInfo(data);
      },
      (error) => {
        // console.error('Error fetching payment info:', error);
      }
    );

    // Set loading to false after both data sources are fetched
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    // Fetch legal info
    const legalRef = ref(database, "videoplayer/legal");
    const unsubscribeLegal = onValue(legalRef, (snapshot) => {
      setLegalInfo(snapshot.val());
    });

    return () => {
      unsubscribeInstructions();
      unsubscribeSubscription();
      unsubscribePayment();
      clearTimeout(timer);
      unsubscribeLegal();
    };
  }, []);

  // Handle advertisement overlay timer
  useEffect(() => {
    let interval;
    if (showAdOverlay && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => {
          if (prev <= 1) {
            setShowAdOverlay(false);
            setAdTimer(15);
            return 15;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showAdOverlay, adTimer]);

  const handleCloseAd = () => {
    setShowAdOverlay(false);
    setAdTimer(15);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Validation for Name (only letters)
    if (name === "name") {
      if (/^[A-Za-z]*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
        setNameError("");
      } else {
        setNameError("Only letters are allowed");
      }
      return;
    }
    // Validation for Surname (only letters)
    if (name === "surname") {
      if (/^[A-Za-z]*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
        setSurnameError("");
      } else {
        setSurnameError("Only letters are allowed");
      }
      return;
    }
    // Validation for Email
    if (name === "email") {
      // Allow any input while typing, but show error for invalid format
      setFormData((prev) => ({ ...prev, [name]: value }));
      
      if (value === "") {
        setEmailError("");
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(value)) {
          setEmailError("");
        } else {
          setEmailError("Please enter a valid email address");
        }
      }
      return;
    }
    // Validation for Mobile (only numbers, max 10 digits)
    if (name === "mobile") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.length === 10) {
          setMobileError("");
        } else {
          setMobileError("Mobile number must be 10 digits");
        }
      }
      return;
    }
    // Validation for GST (only numbers, allow decimal)
    if (name === "gst") {
      if (/^\d*\.?\d*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
        setGstError("");
      } else {
        setGstError("Only numbers are allowed");
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "password" || name === "confirmPassword") {
      if (
        formData.password &&
        formData.confirmPassword &&
        formData.password !== formData.confirmPassword
      ) {
        setPasswordError("Passwords do not match");
      } else {
        setPasswordError("");
      }
    }

    if (name === "payment" && (value === "gpay" || value === "phonepe")) {
      setShowQR(true);
    } else if (name === "payment" && value !== "gpay" && value !== "phonepe") {
      setShowQR(false);
    }
  };

  const handleScreenshotChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setScreenshotFile(file);
      const previewUrl = URL.createObjectURL(file);
      setScreenshotPreview(previewUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionError("");

    if (!formData.terms) {
      alert("Please agree to the terms and conditions.");
      return;
    }

    if (!formData.plan) {
      alert("Please select a subscription plan.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    if (!formData.visitBranch) {
      alert("Please select whether you want to visit the branch.");
      return;
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      setIsUploadingScreenshot(true);

      let screenshotUrl = "";

      // Upload screenshot if provided
      if (screenshotFile) {
        try {
          // console.log('Starting screenshot upload...');
          const screenshotRef = storageRef(
            storage,
            `videoplayer/payment/${formData.mobile}/payment_screenshot`
          );
          // console.log('Storage reference created:', screenshotRef);
          const screenshotSnapshot = await uploadBytes(
            screenshotRef,
            screenshotFile
          );
          // console.log('Screenshot uploaded successfully');
          screenshotUrl = await getDownloadURL(screenshotSnapshot.ref);
          // console.log('Download URL obtained:', screenshotUrl);
        } catch (uploadError) {
          // console.error('Error uploading screenshot:', uploadError);
          alert("Error uploading screenshot. Please try again.");
          return;
        }
      }

      // Create user data object
      const submissionData = {
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        mobile: formData.mobile,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        business: formData.business,
        gst: formData.gst,
        payment: formData.payment,
        terms: formData.terms,
        plan: formData.plan,
        visitBranch: formData.visitBranch,
        screenshotUrl,
        status: "pending",
        timestamp: new Date().toISOString(),
      };

      // Save to database
      // console.log('Creating database reference...');
      const userRef = ref(database, `videoplayer/Users/${formData.mobile}`);
      // console.log('Database reference created:', userRef);
      // console.log('Saving submission data:', submissionData);
      await set(userRef, submissionData);
      // console.log('Data saved successfully');

      alert(
        "Form submitted successfully! Your information and payment screenshot have been saved."
      );

      // Reset form
      setFormData({
        name: "",
        surname: "",
        email: "",
        mobile: "",
        password: "",
        confirmPassword: "",
        business: "",
        gst: "",
        payment: "",
        terms: false,
        plan: "",
        visitBranch: "",
      });
      setScreenshotFile(null);
      setScreenshotPreview("");
      setShowQR(false);
    } catch (error) {
      // console.error('Error saving data to Firebase:', error);
      setSubmissionError("Failed to submit form. Please try again later.");
      alert("Failed to submit form. Please try again later.");
    } finally {
      setIsUploadingScreenshot(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading information...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Advertisement Overlay */}
      {showAdOverlay && instructionData?.adImageUrl && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
          <div className="relative max-w-4xl max-h-full p-4">
            {/* Close Button */}
            <button
              onClick={handleCloseAd}
              className="absolute top-4 right-4 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-full p-2 transition-all duration-300 backdrop-blur-sm"
            >
              <FaTimes className="w-5 h-5" />
            </button>

            {/* Timer Display */}
            <div className="absolute top-4 left-4 z-10 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-sm font-medium">
              {adTimer}s
            </div>

            {/* Advertisement Image */}
            <img
              src={instructionData.adImageUrl}
              alt="Advertisement"
              className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />

            {/* Skip Button */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
              <button
                onClick={handleCloseAd}
                className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-6 py-2 rounded-full transition-all duration-300 backdrop-blur-sm font-medium"
              >
                Skip ({adTimer}s)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Header */}
      <div className="bg-yellow-500 shadow-2xl border-b border-yellow-600/30 sticky top-0 z-40">
        {/* Header Notice - always on desktop, only in menu on mobile */}
        <div className="hidden md:block w-full bg-yellow-100 border-b border-yellow-300 text-yellow-900 text-center py-2 font-semibold text-sm tracking-wide">
          No phone calls, only WhatsApp
        </div>
        {/* Desktop Header */}
        <div className="hidden md:block">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-4">
              {/* Logo/Brand */}
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                    TimepassServices
                  </h1>
                </div>
              </div>

              {/* Contact Information */}
              <div className="flex items-center space-x-8">
                {/* WhatsApp 1 */}
                <a
                  href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full hover:from-green-600 hover:to-emerald-700 transition-all duration-300 group shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <FaWhatsapp className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
                  <span className="text-sm font-semibold hidden lg:block">
                    {contactInfo.whatsapp}
                  </span>
                </a>
                <a
                  href={`https://wa.me/${contactInfo.whatsapp2.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full hover:from-green-600 hover:to-emerald-700 transition-all duration-300 group shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <FaWhatsapp className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
                  <span className="text-sm font-semibold hidden lg:block">
                     {contactInfo.whatsapp2}
                  </span>
                </a>

                {/* Email */}
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center space-x-3 px-4 py-2 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-full hover:from-orange-600 hover:to-red-700 transition-all duration-300 group shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <FaEnvelope className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
                  <span className="text-sm font-semibold hidden lg:block">
                    {contactInfo.email}
                  </span>
                </a>

                {/* Website */}
                <a
                  href={contactInfo.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-full hover:from-purple-600 hover:to-pink-700 transition-all duration-300 group shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <FaGlobe className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
                  <span className="text-sm font-semibold hidden lg:block">
                    https://timepassservices.com/
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Header */}
        <div className="md:hidden">
          <div className="px-3 sm:px-4 py-3 sm:py-4">
            <div className="flex items-center justify-between relative">
              {/* Invisible spacer for centering */}
              <div className="w-10 h-10 flex-shrink-0"></div>

              {/* Centered Logo */}
              <div className="absolute left-1/2 transform -translate-x-1/2">
                <h1 className="text-[25px] sm:text-xs font-bold text-white drop-shadow-lg">
                  TimepassServices
                </h1>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 sm:p-2.5 rounded-xl bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 transition-all duration-300 border border-white/25 shadow-lg z-10"
              >
                {isMobileMenuOpen ? (
                  <FaClose className="w-4 h-4 sm:w-5 sm:h-5" />
                ) : (
                  <FaBars className="w-4 h-4 sm:w-5 sm:h-5" />
                )}
              </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="mt-3 sm:mt-4 pb-3 sm:pb-4 border-t border-white/20">
                {/* Header Notice for Mobile - only when menu is open */}
                <div className="block md:hidden w-full bg-yellow-100 border-b border-yellow-300 text-yellow-900 text-center py-2 font-semibold text-sm tracking-wide mb-2">
                  No phone calls, only WhatsApp
                </div>
                <div className="pt-3 sm:pt-4 space-y-2 sm:space-y-3">
                  {/* WhatsApp 1 */}
                  <a
                    href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center p-3 sm:p-4 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl sm:rounded-2xl hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-[1.02] shadow-xl border border-white/10"
                  >
                    <div className="bg-white/20 p-2 sm:p-3 rounded-lg sm:rounded-xl mr-3 sm:mr-4">
                      <FaWhatsapp className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs sm:text-sm text-white/90 font-semibold mb-0.5 sm:mb-1">
                        WhatsApp
                      </p>
                      <p className="text-sm sm:text-base font-bold text-white truncate">
                        {contactInfo.whatsapp}
                      </p>
                    </div>
                    <div className="bg-white/20 px-2 sm:px-3 py-1 rounded-full ml-2">
                      <span className="text-xs font-medium text-white">
                        Chat
                      </span>
                    </div>
                  </a>
                  <a
                    href={`https://wa.me/${contactInfo.whatsapp2.replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center p-3 sm:p-4 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl sm:rounded-2xl hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-[1.02] shadow-xl border border-white/10"
                  >
                    <div className="bg-white/20 p-2 sm:p-3 rounded-lg sm:rounded-xl mr-3 sm:mr-4">
                      <FaWhatsapp className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs sm:text-sm text-white/90 font-semibold mb-0.5 sm:mb-1">
                        Business WhatsApp
                      </p>
                      <p className="text-sm sm:text-base font-bold text-white truncate">
                        {contactInfo.whatsapp2}
                      </p>
                    </div>
                    <div className="bg-white/20 px-2 sm:px-3 py-1 rounded-full ml-2">
                      <span className="text-xs font-medium text-white">
                        Chat
                      </span>
                    </div>
                  </a>

                  {/* Email */}
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="flex items-center p-3 sm:p-4 bg-gradient-to-r from-orange-500 to-red-600 rounded-xl sm:rounded-2xl hover:from-orange-600 hover:to-red-700 transition-all duration-300 transform hover:scale-[1.02] shadow-xl border border-white/10"
                  >
                    <div className="bg-white/20 p-2 sm:p-3 rounded-lg sm:rounded-xl mr-3 sm:mr-4">
                      <FaEnvelope className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs sm:text-sm text-white/90 font-semibold mb-0.5 sm:mb-1">
                        Email
                      </p>
                      <p className="text-xs sm:text-sm font-bold text-white break-all leading-tight">
                        {contactInfo.email}
                      </p>
                    </div>
                    <div className="bg-white/20 px-2 sm:px-3 py-1 rounded-full ml-2">
                      <span className="text-xs font-medium text-white">
                        Mail
                      </span>
                    </div>
                  </a>

                  {/* Website */}
                  <a
                    href={contactInfo.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center p-3 sm:p-4 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl sm:rounded-2xl hover:from-purple-600 hover:to-pink-700 transition-all duration-300 transform hover:scale-[1.02] shadow-xl border border-white/10"
                  >
                    <div className="bg-white/20 p-2 sm:p-3 rounded-lg sm:rounded-xl mr-3 sm:mr-4">
                      <FaGlobe className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs sm:text-sm text-white/90 font-semibold mb-0.5 sm:mb-1">
                        Website
                      </p>
                      <p className="text-xs sm:text-sm font-bold text-white break-all leading-tight">
                        timepassservices.com
                      </p>
                    </div>
                    <div className="bg-white/20 px-2 sm:px-3 py-1 rounded-full ml-2">
                      <span className="text-xs font-medium text-white">
                        Visit
                      </span>
                    </div>
                  </a>
                </div>

                {/* Quick Contact Summary */}
                <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-white/10 rounded-xl sm:rounded-2xl backdrop-blur-sm border border-white/20">
                  <h3 className="text-xs sm:text-sm font-semibold text-white/90 mb-2">
                    Quick Contact
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 text-xs">
                    <div className="text-white/80">
                      <span className="font-medium">WhatsApp 1:</span>{" "}
                      {contactInfo.whatsapp}
                    </div>
                    <div className="text-white/80">
                      <span className="font-medium">Business WhatsApp:</span>{" "}
                      {contactInfo.whatsapp2}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main Page Content */}
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Registration Form */}
          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-6 flex items-center justify-center gap-2">
              <FaUser className="text-indigo-600" />
              User Registration
            </h2>
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="name"
                >
                  <FaUser className="inline-block mr-2 text-indigo-500" /> Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                  placeholder="Enter your name"
                  required
                  pattern="[A-Za-z]+"
                  maxLength="30"
                  autoComplete="off"
                />
                {nameError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {nameError}
                  </p>
                )}
              </div>

              {/* Surname Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="surname"
                >
                  <FaUserTag className="inline-block mr-2 text-indigo-500" />{" "}
                  Surname
                </label>
                <input
                  type="text"
                  id="surname"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                  placeholder="Enter your surname"
                  required
                  pattern="[A-Za-z]+"
                  maxLength="30"
                  autoComplete="off"
                />
                {surnameError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {surnameError}
                  </p>
                )}
              </div>

              {/* Email Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="email"
                >
                  <FaEnvelope className="inline-block mr-2 text-indigo-500" />{" "}
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                  placeholder="Enter your email address"
                  required
                  autoComplete="email"
                />
                {emailError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {emailError}
                  </p>
                )}
              </div>

              {/* Mobile Number Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="mobile"
                >
                  <FaPhone className="inline-block mr-2 text-indigo-500" />{" "}
                  Mobile Number
                </label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                  placeholder="Enter your mobile number"
                  pattern="[0-9]{10}"
                  maxLength="10"
                  minLength="10"
                  required
                  autoComplete="off"
                />
                {mobileError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {mobileError}
                  </p>
                )}
              </div>

              {/* Password Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="password"
                >
                  <FaLock className="inline-block mr-2 text-indigo-500" />{" "}
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                    placeholder="Enter your password"
                    required
                    minLength="8"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  >
                    {showPassword ? (
                      <FaEyeSlash className="w-5 h-5" />
                    ) : (
                      <FaEye className="w-5 h-5" />
                    )}
                  </button>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="confirmPassword"
                >
                  <FaLock className="inline-block mr-2 text-indigo-500" />{" "}
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                    placeholder="Confirm your password"
                    required
                    minLength="8"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  >
                    {showConfirmPassword ? (
                      <FaEyeSlash className="w-5 h-5" />
                    ) : (
                      <FaEye className="w-5 h-5" />
                    )}
                  </button>
                </div>
                {passwordError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {passwordError}
                  </p>
                )}
              </div>

              {/* Business Option */}
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">
                  <FaBriefcase className="inline-block mr-2 text-indigo-500" />{" "}
                  Do you own a business?
                </label>
                <div className="flex gap-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="business"
                      value="yes"
                      checked={formData.business === "yes"}
                      onChange={handleChange}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-400 transition-all duration-300"
                      required
                    />
                    <span className="ml-2 text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="business"
                      value="no"
                      checked={formData.business === "no"}
                      onChange={handleChange}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-400 transition-all duration-300"
                    />
                    <span className="ml-2 text-gray-600">No</span>
                  </label>
                </div>
              </div>

              {/* Visit Branch Option */}
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">
                  <FaBuilding className="inline-block mr-2 text-indigo-500" />{" "}
                  Do you work For Branch officesir?
                </label>
                <div className="flex gap-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="visitBranch"
                      value="yes"
                      checked={formData.visitBranch === "yes"}
                      onChange={handleChange}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-400 transition-all duration-300"
                      required
                    />
                    <span className="ml-2 text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="visitBranch"
                      value="no"
                      checked={formData.visitBranch === "no"}
                      onChange={handleChange}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-400 transition-all duration-300"
                    />
                    <span className="ml-2 text-gray-600">No</span>
                  </label>
                </div>
              </div>

              {/* GST Percentage */}
              <div className="relative">
                <label
                  className="block text-gray-700 text-sm font-medium mb-1"
                  htmlFor="gst"
                >
                  <FaPercentage className="inline-block mr-2 text-indigo-500" />{" "}
                  GST %
                </label>
                <input
                  type="text"
                  id="gst"
                  name="gst"
                  value={formData.gst}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition-all duration-300 ease-in-out hover:border-indigo-300"
                  placeholder="Enter GST percentage"
                  maxLength="5"
                  autoComplete="off"
                />
                {gstError && (
                  <p className="text-red-500 text-sm mt-1 animate-pulse">
                    {gstError}
                  </p>
                )}
              </div>

              {/* Subscription Plans */}
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-3">
                  <FaCamera className="inline-block mr-2 text-indigo-500" />{" "}
                  Select Subscription Plan
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <label
                    className={`relative p-4 border rounded-xl cursor-pointer transition-all duration-300 ${
                      formData.plan === "yearly"
                        ? "border-indigo-500 bg-indigo-50 shadow-md"
                        : "border-gray-200 hover:border-indigo-300 hover:shadow-sm"
                    }`}
                  >
                    <input
                      type="radio"
                      name="plan"
                      value="yearly"
                      checked={formData.plan === "yearly"}
                      onChange={handleChange}
                      className="absolute opacity-0"
                      required
                    />
                    <div className="text-center">
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        Yearly Plan
                      </h3>
                      <p className="text-gray-600 text-sm mb-1">
                        1 Photo or 1 Video Upload per Year
                      </p>
                      <p className="text-xl font-bold text-indigo-600 mb-1">
                        ₹{subscriptionPlans?.yearly?.price}/year
                      </p>
                      <p className="text-xs text-gray-500">Valid for 1 year</p>
                    </div>
                  </label>
                  <label
                    className={`relative p-4 border rounded-xl cursor-pointer transition-all duration-300 ${
                      formData.plan === "unlimited"
                        ? "border-indigo-500 bg-indigo-50 shadow-md"
                        : "border-gray-200 hover:border-indigo-300 hover:shadow-sm"
                    }`}
                  >
                    <input
                      type="radio"
                      name="plan"
                      value="unlimited"
                      checked={formData.plan === "unlimited"}
                      onChange={handleChange}
                      className="absolute opacity-0"
                      required
                    />
                    <div className="text-center">
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        Unlimited Plan
                      </h3>
                      <p className="text-gray-600 text-sm mb-1">
                        Unlimited Photo & Video Uploads per Year
                      </p>
                      <p className="text-xl font-bold text-indigo-600 mb-1">
                        ₹{subscriptionPlans?.unlimited?.price}/year
                      </p>
                      <p className="text-xs text-gray-500">
                        Unlimited access for 1 year
                      </p>
                    </div>
                  </label>
                </div>
              </div>

              {/* Payment Method */}
              <div className="relative">
                <label className="block text-gray-700 text-sm font-medium mb-1">
                  <FaCreditCard className="inline-block mr-2 text-indigo-500" />{" "}
                  Payment Method
                </label>
                {!formData.plan && (
                  <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                    <p className="text-sm text-yellow-700">
                      ⚠️ Please select a subscription plan first to see payment
                      options
                    </p>
                  </div>
                )}
                <div
                  className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${
                    !formData.plan ? "opacity-50 pointer-events-none" : ""
                  }`}
                >
                  {/* GPay Option */}
                  <label
                    className={`relative p-4 border rounded-xl cursor-pointer transition-all duration-300 ${
                      formData.payment === "gpay"
                        ? "border-green-500 bg-green-50 shadow-md"
                        : "border-gray-200 hover:border-green-300 hover:shadow-sm"
                    }`}
                  >
                    <input
                      type="radio"
                      name="payment"
                      value="gpay"
                      checked={formData.payment === "gpay"}
                      onChange={handleChange}
                      className="absolute opacity-0"
                      required
                    />
                    <div className="text-center">
                      <div className="flex items-center justify-center mb-2">
                        <img src={gpayImg} alt="GPay" className="h-8 w-8" />
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        GPay
                      </h3>
                      <p className="text-sm text-gray-600">Google Pay</p>
                    </div>
                  </label>

                  {/* PhonePe Option */}
                  <label
                    className={`relative p-4 border rounded-xl cursor-pointer transition-all duration-300 ${
                      formData.payment === "phonepe"
                        ? "border-purple-500 bg-purple-50 shadow-md"
                        : "border-gray-200 hover:border-purple-300 hover:shadow-sm"
                    }`}
                  >
                    <input
                      type="radio"
                      name="payment"
                      value="phonepe"
                      checked={formData.payment === "phonepe"}
                      onChange={handleChange}
                      className="absolute opacity-0"
                      required
                    />
                    <div className="text-center">
                      <div className="flex items-center justify-center mb-2">
                        <img
                          src={phonepeImg}
                          alt="PhonePe"
                          className="h-8 w-8"
                        />
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        PhonePe
                      </h3>
                      <p className="text-sm text-gray-600">PhonePe Payment</p>
                    </div>
                  </label>
                </div>
              </div>

              {/* Payment Number Display */}
              {showQR && paymentInfo && formData.plan && (
                <div className="animate-slide-in mb-4">
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                    <div className="text-center">
                      <div className="flex items-center justify-center mb-4">
                        {formData.payment === "gpay" ? (
                          <img
                            src={gpayImg}
                            alt="GPay"
                            className="h-12 w-12 mb-2"
                          />
                        ) : (
                          <img
                            src={phonepeImg}
                            alt="PhonePe"
                            className="h-12 w-12 mb-2"
                          />
                        )}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        {formData.payment === "gpay" ? "GPay" : "PhonePe"}{" "}
                        Payment
                      </h3>

                      {/* Plan Price Display */}
                      <div className="bg-indigo-50 p-4 rounded-lg mb-4">
                        <p className="text-sm text-gray-600 mb-1">
                          Selected Plan:
                        </p>
                        <p className="text-lg font-semibold text-indigo-800">
                          {formData.plan === "yearly"
                            ? "Yearly Plan"
                            : "Unlimited Plan"}
                        </p>
                        <p className="text-2xl font-bold text-indigo-600">
                          ₹
                          {formData.plan === "yearly"
                            ? subscriptionPlans?.yearly?.price
                            : subscriptionPlans?.unlimited?.price}
                        </p>
                      </div>

                      {/* Payment Number */}
                      <div className="bg-gray-50 p-4 rounded-lg mb-4">
                        <p className="text-sm text-gray-600 mb-2">
                          {formData.payment === "gpay" ? "GPay" : "PhonePe"}{" "}
                          Number:
                        </p>
                        <p className="text-2xl font-bold text-gray-800">
                          {formData.payment === "gpay"
                            ? paymentInfo.gpayNumber
                            : paymentInfo.phonepeNumber}
                        </p>
                      </div>

                      {/* Payment Instructions */}
                      <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
                        <p className="text-sm text-yellow-800 font-medium">
                          💳 Payment Instructions:
                        </p>
                        <p className="text-sm text-yellow-700 mt-1">
                          Send ₹
                          {formData.plan === "yearly"
                            ? subscriptionPlans?.yearly?.price
                            : subscriptionPlans?.unlimited?.price}{" "}
                          to the above{" "}
                          {formData.payment === "gpay" ? "GPay" : "PhonePe"}{" "}
                          number
                        </p>
                        <p className="text-xs text-yellow-600 mt-2">
                          After payment, please upload the transaction
                          screenshot below
                        </p>
                      </div>

                      {/* Screenshot Upload Section */}
                      <div className="mt-6">
                        <label className="block text-gray-700 text-sm font-medium mb-3">
                          <FaImage className="inline-block mr-2 text-indigo-500" />
                          Upload Payment Screenshot
                        </label>

                        <div className="space-y-4">
                          {/* File Upload */}
                          <div className="flex items-center gap-4">
                            <label className="cursor-pointer bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition duration-200 flex items-center text-sm">
                              <FaUpload className="mr-2" />
                              Choose Screenshot
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleScreenshotChange}
                                className="hidden"
                                required
                              />
                            </label>
                            <span className="text-sm text-gray-500">
                              Upload your payment transaction screenshot
                            </span>
                          </div>

                          {/* Screenshot Preview */}
                          {screenshotPreview && (
                            <div className="bg-gray-50 p-4 rounded-lg">
                              <p className="text-sm text-gray-600 mb-2">
                                Screenshot Preview:
                              </p>
                              <img
                                src={screenshotPreview}
                                alt="Payment Screenshot"
                                className="max-w-full h-48 object-contain rounded-lg shadow-sm border border-gray-200"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Submission Error */}
              {submissionError && (
                <p className="text-red-500 text-sm mt-1 animate-pulse">
                  {submissionError}
                </p>
              )}
              {/* Terms and Conditions */}
              <div>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={formData.terms}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-400 transition-all duration-300"
                    required
                  />
                  <span className="ml-2 text-gray-600 text-sm">
                    I agree to the{" "}
                    <a
                      href="#"
                      className="text-indigo-600 hover:text-indigo-800 transition duration-300"
                    >
                      Terms and Conditions
                    </a>
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isUploadingScreenshot}
                className={`w-full py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105 ${
                  isUploadingScreenshot
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700 text-white"
                }`}
              >
                {isUploadingScreenshot ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Uploading Screenshot...</span>
                  </>
                ) : (
                  <>
                    <FaCheckCircle />
                    <span>Submit</span>
                  </>
                )}
              </button>

              {/* Back to Login Link */}
              <div className="text-center mt-4">
                <p className="text-gray-600 text-sm">
                  Already have an account?{" "}
                  <Link
                    to="/login"
                    className="text-indigo-600 hover:text-indigo-800 font-medium transition duration-300"
                  >
                    Login
                  </Link>
                </p>
              </div>
            </form>
          </div>

          {/* Instruction Information Section */}
          {instructionData && (
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 mb-8">
              <div className="text-center mb-6">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 flex items-center justify-center gap-2">
                  <FaInfoCircle className="text-indigo-600" />
                  Important Information Instructions
                </h1>
                <div className="w-24 h-1 bg-indigo-600 mx-auto rounded-full"></div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                {/* Information Text */}
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-indigo-500">
                    <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                      {instructionData.information}
                    </p>
                  </div>
                </div>

                {/* Information Image */}
                {instructionData.infoImageUrls &&
                instructionData.infoImageUrls.length > 0 ? (
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">
                      Information Images
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {instructionData.infoImageUrls.map((url, idx) => (
                        <div className="relative" key={idx}>
                          <img
                            src={url}
                            alt={`Information ${idx + 1}`}
                            className="w-full h-64 object-cover rounded-lg shadow-lg border border-gray-200"
                          />
                          <span className="absolute top-2 left-2 bg-black bg-opacity-50 text-white text-xs px-2 py-0.5 rounded">
                            {idx + 1}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : instructionData.infoImageUrl ? (
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">
                      Information Image
                    </h3>
                    <div className="relative">
                      <img
                        src={instructionData.infoImageUrl}
                        alt="Information"
                        className="w-full h-64 object-cover rounded-lg shadow-lg"
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          )}

          {/* Legal Information Section */}
          {legalInfo && (
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8">
              <div className="text-center mb-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 flex items-center justify-center gap-2">
                  <FaInfoCircle className="text-indigo-600" />
                  Legal
                </h2>
                <div className="w-24 h-1 bg-indigo-600 mx-auto rounded-full"></div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                {/* Legal Text */}
                <div className="space-y-4">
                  {/* <h3 className="text-lg font-semibold text-gray-800 mb-3">Legal Notice</h3> */}
                  <div className="bg-gray-50 p-4 rounded-lg border-4 border-indigo-500">
                    <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                      {legalInfo.legalText}
                    </p>
                  </div>
                </div>
                {/* Legal Image */}
                {legalInfo.legalImageUrl && (
                  <div className="space-y-4">
                    {/* <h3 className="text-lg font-semibold text-gray-800 mb-3">Legal Image</h3> */}
                    <div className="relative">
                      <img
                        src={legalInfo.legalImageUrl}
                        alt="Legal"
                        className="w-full h-64 object-cover rounded-lg shadow-lg"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-in {
          animation: slideIn 0.5s ease-out;
        }
      `}</style>
    </>
  );
};

export default Information;
